import React from 'react';
import './style.scss';
import { Form, InputGroup } from 'react-bootstrap';

interface Props {
    id: string
    value?: string | number | undefined
    onChange? : React.ChangeEventHandler<HTMLInputElement> | undefined
    placeholder: string
    disabled?: boolean | undefined
    readOnly?: boolean | undefined
    type?: React.HTMLInputTypeAttribute
    onBlur? : React.FocusEventHandler<HTMLInputElement> | undefined
    maxLength? : number
    className?: string | undefined,
    label?: string | undefined,
    isInvalid?: boolean | undefined,
    errorMsg?: string,
    defaultValue?: string | number | readonly string[] | undefined;
    leftIcon?: React.ReactElement;
    rightIcon?: React.ReactElement;
}

const DefaultWithIcon: React.FC<Props> = (props) => {
  const {
    value, onChange, placeholder, readOnly, leftIcon,
    label, className, errorMsg, disabled, rightIcon,
    id, onBlur, maxLength, isInvalid,
    defaultValue, type = 'text',
  } = props;

  return (
    <Form.Group className={`w-100 ${className}`}>
      <Form.Label htmlFor={id} className={label ? 'label' : 'd-none'}>{label}</Form.Label>
      <InputGroup>
        <div
          className={`${disabled ? 'bg-disabled' : ''} form-with-icon-input-container px-3`}
          style={isInvalid ? { border: '1px solid red' } : {}}
        >
          <div className={leftIcon ? 'ps-1' : 'd-none'}>{leftIcon}</div>
          <Form.Control
            id={id}
            type={type}
            disabled={disabled}
            isInvalid={isInvalid}
            className="flex-grow-1 border-0 shadow-none px-1 pt-2 fz-14"
            maxLength={maxLength}
            onBlur={onBlur}
            value={value}
            placeholder={placeholder}
            readOnly={readOnly}
            onChange={onChange}
            defaultValue={defaultValue}
            name={id}
          />
          <div className={rightIcon ? 'pe-1' : 'd-none'}>{rightIcon}</div>
        </div>
        <div className={isInvalid ? 'invalidMsg' : 'd-none'}>
          {errorMsg}
        </div>
      </InputGroup>
    </Form.Group>
  );
};

export default DefaultWithIcon;
